import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY,  Observable, switchMap, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ModelDetail } from '../models/model-details.model';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { routes } from '../constants/routes';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

export const modelDetailsResolver: ResolveFn<Observable<ModelDetail>> = (
  route: ActivatedRouteSnapshot,
) => {
  const slug: string = route.params['slug'].split('.html')[0];
  const router = inject(Router);
  const apiService = inject(ApiService);

  const utilityService = inject(UtilityService);
  const navigationService = inject(NavigationService)
  const analyticsService = inject(AnalyticsService);

  const isModelTryout = route.data['isModelTryout'] as boolean;

  if (utilityService.isUserLoggedIn()) {
    const openAddModel = route.queryParams['openAddModel'];
    const url = openAddModel === 'true'
      ? `${webRedirectionUrl.modelsAll}?openAddModel=true`
      : `${isModelTryout ? webRedirectionUrl.modelTryoutDetails : webRedirectionUrl.modelDetails}${slug}.html`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.fetchModelDetails(slug).pipe(
      switchMap((resp) => {
        if (resp.header.success && resp.data) {
          if (resp.data?.isTryoutAvailable && !isModelTryout) {
            router.navigate(['/', routes.home, routes.modelTryout, routes.details, slug + '.html']);
            return EMPTY;
          }
          return [resp.data];
        }

        throw new Error(resp.header.msg);
      }),
      tap((data) => {
        analyticsService.logEvent('model_view', {
          id: data?.id,
          name: data?.name,
          slug: data?.slug,
        });
      }),
      catchError((error) => {
       navigationService.handleResolverError(error);
        return EMPTY;
      }),
    );
  }
};
